enum TextSearchAreaTabs {
  YourText = 'html',
  ByTopic = 'keywords',
}

export default TextSearchAreaTabs;
